import BaseFeature from '../../foundation/base/base';

class AccessibilityTools extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;

		element.addEventListener('keyup', () => {
			document.querySelector('body').classList.add('using-keyboard');
		}, false);
		element.addEventListener('click', () => {
			document.querySelector('body').classList.remove('using-keyboard');
		}, false);
		element.addEventListener('touchstart', () => {
			document.querySelector('body').classList.remove('using-keyboard');
		}, false);
	}
}


export default AccessibilityTools;
